import { UnauthorizedError, NotFoundError, ServerError, GenericError, ErrorType } from '../../data-types/error-types';

export class ErrorFactory {

  static getError(errorCode: number): ErrorType {
    switch (errorCode) {
      case 401:
        return new UnauthorizedError();
      case 404:
        return new NotFoundError();
      case 500:
        return new ServerError();
      default:
        return new GenericError();
    }
  }
}
